export enum NewsBnrActionTypes {
  API_RESPONSE_SUCCESS = "@@BnrNews/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@BnrNews/API_RESPONSE_ERROR",

  CREATE_NEWS_IMAGE = "@@BnrNews/CREATE_NEWS_IMAGE",
  GET_NEWS_IMAGE = "@@BnrNews/GET_NEWS_IMAGE",
  UPDATE_NEWS_IMAGE = "@@BnrNews/UPDATE_NEWS_IMAGE",
  DELETE_NEWS_IMAGE = "@@BnrNews/DELETE_NEWS_IMAGE",
}
